import { Box } from "@mui/system";
import { FileViewerDialogInitValues } from "../FileViewerDialog";

import type { JSX } from "react";

export type UnsupportedViewerProps = FileViewerDialogInitValues;

export function UnsupportedViewer({
    title,
    url,
    mimeType
}: UnsupportedViewerProps): JSX.Element {
    return (
        <Box>
            Unsupported File Type
        </Box>
    );
}